import React from 'react';

import { ENV } from '@environment';
import GoogleMapReact from 'google-map-react';

import { MapBottomAddress, Container, Dot } from './styles';

interface Props {
  lat: number;
  lng: number;
  address: string;
}

interface MapPinProps {
  lat: number;
  lng: number;
}

const googleMapsKey = ENV.API_KEYS.GOOGLE_MAPS_API_KEY as string;

const MapPin = ({ lat, lng }: MapPinProps) => <Dot />;

const Map = ({ lat, lng, address }: Props) => {
  const mapCenter = {
    lat,
    lng,
  };

  return (
    <>
      <Container>
        <GoogleMapReact
          bootstrapURLKeys={{ key: googleMapsKey }}
          defaultCenter={mapCenter}
          defaultZoom={10}
          options={{ fullscreenControl: false, gestureHandling: 'cooperative' }}
        >
          <MapPin lat={lat} lng={lng} />
        </GoogleMapReact>
        <MapBottomAddress>{address}</MapBottomAddress>
      </Container>
    </>
  );
};

export default Map;
